import { render, staticRenderFns } from "./PortalPopover.vue?vue&type=template&id=5c88293f&scoped=true&"
import script from "./PortalPopover.vue?vue&type=script&lang=js&"
export * from "./PortalPopover.vue?vue&type=script&lang=js&"
import style0 from "./PortalPopover.vue?vue&type=style&index=0&id=5c88293f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88293f",
  null
  
)

export default component.exports